import { takeLatest, put, call, fork } from 'redux-saga/effects';
import DashboardTypes from './dashboard.types';
import {
	getDashboardData,
	getDashboardDataEnhanced,
	getDashboardEmployeeListEnhanced,
} from './dashboard.service';
import {
	dashboardSuccess,
	dashboardFailure,
	dashboardEnhancedSuccess,
	dashboardEnhancedFailure,
	employeeListEnhancedSuccess,
	employeeListEnhancedFailure,
} from './dashboard.action';
import AlertManager from '../../utils/alertManager';
import { encryptData } from '../_common/enode-decode';

export function* fetchSectionWiseDataSaga(payload: any) {
	try {
		const key = 'fetchSectionWiseDataKey';
		const DashboardAttendance =
			payload.payload.branchID === 'all' || payload.payload.branchID === ''
				? 'DashboardAttendanceDetailsforAll'
				: 'DashboardAttendanceDetails';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(
			getDashboardData as any,
			encryptedData,
			DashboardAttendance,
		);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				console.log('Received failure response');
				yield put(dashboardFailure(responseData.data));
			} else {
				console.log('Received success response');
				yield put(dashboardSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		console.error('Error in fetchSectionWiseData:', error);
		yield put(dashboardFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onDashboardStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.DASHBOARD_START as any, fetchSectionWiseDataSaga);
}

// Enhanced Dashboard Saga
export function* fetchDashboardEnhancedSaga(payload: any) {
	try {
		const key = 'fetchDashboardEnhancedKey';
		const encryptedData = encryptData(payload.payload, key);
		console.log('fetchDashboardEnhancedSaga called with payload:', payload);
		// @ts-ignore
		const responseData = yield call(getDashboardDataEnhanced as any, encryptedData);
		console.log('Enhanced Dashboard API call completed, responseData:', responseData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				console.log('Received enhanced dashboard failure response:', responseData.data);
				yield put(dashboardEnhancedFailure(responseData.data));
			} else {
				console.log('Received enhanced dashboard success response:', responseData.data);
				yield put(dashboardEnhancedSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		console.error('Error in fetchDashboardEnhanced saga:', error);
		console.error('Error details:', error?.response?.data);
		yield put(dashboardEnhancedFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onDashboardEnhancedStart(): Generator<any, void, any> {
	console.log('onDashboardEnhancedStart: Setting up watcher for DASHBOARD_ENHANCED_START');
	yield takeLatest(DashboardTypes.DASHBOARD_ENHANCED_START as any, fetchDashboardEnhancedSaga);
	console.log('onDashboardEnhancedStart: Watcher setup completed');
}

// Enhanced Employee List Saga
export function* fetchEmployeeListEnhancedSaga(payload: any) {
	try {
		const key = 'fetchEmployeeListEnhancedKey';
		console.log('fetchEmployeeListEnhancedSaga called with payload:', payload);
		const encryptedData = encryptData(payload.payload, key);
		console.log('fetchEmployeeListEnhancedSaga encryptedData:', encryptedData);
		// @ts-ignore
		const responseData = yield call(getDashboardEmployeeListEnhanced as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				console.log('Received enhanced employee list failure response');
				yield put(employeeListEnhancedFailure(responseData.data));
			} else {
				console.log('Received enhanced employee list success response');
				yield put(employeeListEnhancedSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		console.error('Error in fetchEmployeeListEnhanced:', error);
		yield put(
			employeeListEnhancedFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onEmployeeListEnhancedStart(): Generator<any, void, any> {
	yield takeLatest(
		DashboardTypes.EMPLOYEE_LIST_ENHANCED_START as any,
		fetchEmployeeListEnhancedSaga,
	);
}

export function* dashboardSaga(): Generator<any, void, any> {
	console.log('Dashboard saga starting...');
	yield fork(onDashboardStart);
	yield fork(onDashboardEnhancedStart);
	yield fork(onEmployeeListEnhancedStart);
	console.log('Dashboard saga: All watchers forked');
}
